import { stringifyParameters } from '../helpers';
import { IGiftCardDesignApi } from '../types/giftcard-design.types';
import { instance } from './instance';

export const giftCardDesignApi: IGiftCardDesignApi = {
  listGiftCardDesigns: async (params) => {
    const queryString = stringifyParameters(params);
    return await instance.get(`/gift-card-design${queryString}`);
  },

  getGiftCardDesign: async (id) => {
    return await instance.get(`/gift-card-design/${id}`);
  },

  createGiftCardDesign: async (payload) => {
    return await instance.post('/gift-card-design', payload);
  },

  updateGiftCardDesign: async (id, payload) => {
    return await instance.put(`/gift-card-design/${id}`, payload);
  },
};
